<div class="mat-drawer-inner-container" cdkScrollable #content>
  <ng-content></ng-content>
</div>
